// import { useEffect } from "react";
// import MainLayout from "../../Layout/mainLayout";
// import { useParams } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { showPriceList, editProject, updateShowPriceList } from "../../Redux/Actions/projectActions";
// import "./showPriceList.css";

// const ShowPriceList = () => {
//     const dispatch = useDispatch();
//     const { id } = useParams();

//     useEffect(() => {
//         const payload = {
//             project_id: id,
//             page: 1,
//             limit: 10,
//         };
//         dispatch(showPriceList(payload));
//     }, []);

//     const { priceList } = useSelector((state) => state.projects);

//     const handleToggle = (item) => {
//         const updatedPayload = {
//             id,
//             is_show_price: !item?.is_show_price, // toggle the value
//         };

//         dispatch(updateShowPriceList(updatedPayload)).then(() => {
//             // Refresh price list after updating
//             dispatch(
//                 showPriceList({
//                     project_id: id,
//                     page: 1,
//                     limit: 10,
//                 })
//             );
//         });
//     };

//     return (
//         <MainLayout>
//             <div className="showPriceList-container">
                
//                 {priceList?.data?.map((item, index) => (
//                     <div key={item?.project?._id}>
//                         <div>
//                             <h1>Project Details</h1>
//                             <h3>{item?.project?.project_name}</h3>
//                             <h4>{item?.project?._id}</h4>
//                         </div>

//                         <div>
//                             <label>
//                                 <input
//                                     type="checkbox"
//                                     checked={item?.is_show_price}
//                                     onChange={() => handleToggle(item)}
//                                 />
//                                 Show Price List
//                             </label>


//                             <p>{item?.is_show_price ? "Checked ✅" : "Unchecked ❌"}</p>
//                         </div>
//                     </div>
//                 ))}
//             </div>
//         </MainLayout>
//     );
// };

// export default ShowPriceList;

import { useEffect } from "react";
import MainLayout from "../../Layout/mainLayout";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  showPriceList,
  updateShowPriceList,
} from "../../Redux/Actions/projectActions";
import "./showPriceList.css";
import TableComponent from "../../Global Functions/tableComponents";

const ShowPriceList = () => {
  const dispatch = useDispatch();
  const { id } = useParams();

  const { priceList, loading } = useSelector((state) => state.projects);

  useEffect(() => {
    dispatch(
      showPriceList({
        project_id: id,
        page: 1,
        limit: 10,
      })
    );
  }, [dispatch, id]);

  const handleToggle = (item) => {
    const updatedPayload = {
      id: item._id,
      is_show_price: !item?.is_show_price,
    };

    dispatch(updateShowPriceList(updatedPayload)).then(() => {
      dispatch(
        showPriceList({
          project_id: id,
          page: 1,
          limit: 10,
        })
      );
    });
  };

  const columns = [
    {
      title: "Project Name",
      dataIndex: ["project", "project_name"],
      key: "project_name",
    },
    {
      title: "Brand Name",
      dataIndex: ["project", "brand_name"],
      key: "brand_name",
    },
    {
      title: "User Name",
      dataIndex: ["user", "name"],
      key: "user_name",
    },
    {
      title: "Email",
      dataIndex: ["user", "email"],
      key: "email",
    },
    {
      title: "Phone",
      dataIndex: ["user", "contact_number"],
      key: "contact_number",
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
      render: (text) => new Date(text).toLocaleString(),
    },
    {
      title: "Show Price",
      dataIndex: "is_show_price",
      key: "is_show_price",
      render: (_, item) => (
        <input
          type="checkbox"
          checked={item.is_show_price}
          onChange={() => handleToggle(item)}
        />
      ),
    },
  ];

  const dataSource = priceList?.data || [];

  return (
        <TableComponent
          h3heading="Show Price List"
          setState={() => {}}
          filterFunction={() => {}}
          buttonhead2=""
          navigateTo2=""
          pagination={false}
          onChange={() => {}}
          loading={loading}
          columns={columns}
          dataSource={dataSource}
        />
  );
};

export default ShowPriceList;

